<template>
    <animate-height
        :height="status !== 'not-started' ? 'auto' : 0"
        :duration="200"
        v-on:animationEnd="
        obj => {
            const newHeight = obj.newHeight
            if (newHeight == 0) {
                showNotification = false
            }
        }
        "
    >
        <transition
            enter-active-class="transition ease-out duration-200 delay-75 origin-right"
            enter-from-class="opacity-0 -translate-y-10"
            enter-to-class="opacity-100 translate-y-0"
        >
            <progress-notification
                v-if="showNotification"
                :icon="
                status === 'running'
                    ? faCircleInfo
                    : status === 'completed'
                        ? faCircleCheck
                        : faReplyClock
                "
                :blocks="props.blocks"
                :activeBlock="activeBlock"
                class="border border-solid border-sky-200 transition"
                :class="
                    status !== 'not-started'
                        ? ' '
                        : '-translate-y-10 opacity-0'
                "
            >
                <div>
                    {{ title }}
                </div>
                <template v-slot:caption>
                    {{ caption }}
                </template>
            </progress-notification>
        </transition>
    </animate-height>
</template>

<script setup>
import AnimateHeight from 'vue-animate-height'
import {
    faCircleInfo,
    faReplyClock,
    faCircleCheck,
} from '@fortawesome/pro-solid-svg-icons'
import { ref, watch , computed } from 'vue'
import ProgressNotification from './ProgressNotification.vue'

const status = defineModel('status', {
    type: String,
    default: 'not-started', // possibilities: not-started, running, cancelled, completed
});

const props = defineProps({
    activeBlock: {
        type: Number,
        default: 0,
    },
    blocks: {
        type: Number,
        default: 3,
    },
    defaultTitle: {
        type: String,
        default: 'Preparing your long running process…',
    },
    defaultCaption: {
        type: String,
        default: 'Loading',
    },
});

const startTime = ref(0);
const endTime = ref(0);

const title = computed(() => {
    if (status.value === 'completed') {
        return 'Process complete!';
    }
    if (status.value === 'cancelled') {
        return 'This is taking longer than expected';
    }

    return props.defaultTitle;
});

const caption = computed(() => {
    if (status.value === 'completed') {
        return `Finished in ${Math.floor((endTime.value - startTime.value) / 1000)} seconds.`;
    }
    if (status.value === 'cancelled') {
        return 'Please check back in 10 min.';
    }

    return `${props.defaultCaption}, next update in a few seconds.`;
});

const showNotification = ref(false)

let completedTimeout;
watch(() => status.value, async (currentStatus) => {
    clearTimeout(completedTimeout);
    if (currentStatus === 'not-started') {
        startTime.value = 0;
        endTime.value = 0;
    } else if (currentStatus === 'running') {
        showNotification.value = true;
        startTime.value = Date.now();
    } else if (currentStatus === 'completed') {
        endTime.value = Date.now();

        const duration = endTime.value - startTime.value;
        const delay = duration < 500 ? 0 : 2500;

        completedTimeout = setTimeout(() => {
            status.value = 'not-started';
        }, delay);
    }
}, {
    immediate: true,
})


</script>
